import template from './procedure.html';
import controller from './procedure.controller';
import './procedure.scss';

let procedureComponent = {
  bindings: {},
  template,
  controller
};

export default procedureComponent;



// WEBPACK FOOTER //
// ./client/app/components/procedure/procedure.component.js